import{useAuth as t}from"@phx-husky/use-auth";const r=()=>{const r=t();return{translate:(t,s,...a)=>r.translate(t,s,...a)}};export{r as useTranslations};
